import { render, staticRenderFns } from "./Realms.vue?vue&type=template&id=5dc46128&scoped=true&"
import script from "./Realms.vue?vue&type=script&lang=js&"
export * from "./Realms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc46128",
  null
  
)

export default component.exports